var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publicityDetailWrapper"},[_c('div',{staticClass:"textBox"},[(_vm.type === 5)?_c('Detail5'):(_vm.type === 4)?_c('Detail4'):(_vm.type === 3)?_c('Detail3'):(_vm.type === 2)?_c('Detail2'):_c('Detail1')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }